var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "tit": "이용약관",
      "sc": "이용약관 내용이 들어갑니다.",
      "bg": "/images/sub/visual/sv-use.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('terms-component', {
    attrs: {
      "code": "service"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }